import FJActionConstant from "../../constant/FJActionConstant";
import FJViewConstant from "../../constant/FJViewConstant";

const initState = {
  isExportPanelShow: false, // 是否显示输出视频的面板
  exportProcess: 0, // 输出进度
  qualitySelected: FJViewConstant.RESOLUTION_480P,
  isYoutubeSharing: false,
  youtubeShareProgress: 0,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.CHANGE_EXPORT_RESOLUTION: {
      return {
        ...state,
        qualitySelected: action.resolution,
      }
    }
    case FJActionConstant.CHANGE_EXPORT_PANEL_SHOW_STATE:
      return {
        ...state,
        isExportPanelShow: action.data
      };
    case FJActionConstant.SET_EXPORT_PROGRESS:
      return {
        ...state,
        exportProcess: action.data
      };
    case FJActionConstant.SET_YOUTUBE_SHARING:
      return {
        ...state,
        isYoutubeSharing: action.isYoutubeSharing,
      }
    case FJActionConstant.SET_YOUTUBE_PROGRESS:
      return {
        ...state,
        youtubeShareProgress: action.progress,
      }
    default:
      return state;
  }
}
